import dayjs from 'dayjs'

export function formatESignDate(value: string) {
	return dayjs(value).format('D MMM, YYYY')
}

export function getTodayDateValue() {
	return dayjs().format('YYYY-MM-DD')
}
